import { render, staticRenderFns } from "./agenda.vue?vue&type=template&id=0747302e&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"
import style0 from "./agenda.vue?vue&type=style&index=0&id=0747302e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0747302e",
  null
  
)

export default component.exports